// extracted by mini-css-extract-plugin
module.exports = {"root":"MainTitle_root__3pEJf"};
    if(module.hot) {
      // 1586964020706
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  